// Landing-screen icons, one per game family. Plain inline SVG using
// currentColor so they pick up .game-card-icon's color (and thus each
// theme's --primary) automatically, the same way the mark icons do.

// A dartboard-like target bisected by a dashed line - reads as "halve" once
// paired with the "Halve It" title next to it.
export const HALVEIT_ICON = `<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="2">
    <circle cx="16" cy="16" r="13"/>
    <circle cx="16" cy="16" r="8"/>
    <circle cx="16" cy="16" r="3" fill="currentColor" stroke="none"/>
    <line x1="16" y1="3" x2="16" y2="29" stroke-dasharray="3 3"/>
</svg>`;

// The same circled-X used in-game to mark a closed number - immediately
// familiar to anyone who's played, and distinct from Halve It's icon.
export const CRICKET_ICON = `<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="2.5">
    <circle cx="16" cy="16" r="12"/>
    <line x1="10" y1="10" x2="22" y2="22" stroke-linecap="round"/>
    <line x1="22" y1="10" x2="10" y2="22" stroke-linecap="round"/>
</svg>`;

// A plain concentric dartboard - no dashed halve-line (Halve It) and no
// closed-mark X (Cricket), just the board itself, for the one game that's
// literally "play a normal dartboard down to zero".
export const X01_ICON = `<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="2">
    <circle cx="16" cy="16" r="13"/>
    <circle cx="16" cy="16" r="9"/>
    <circle cx="16" cy="16" r="5"/>
    <circle cx="16" cy="16" r="1.5" fill="currentColor" stroke="none"/>
</svg>`;

// A small target over crossbones - the "you're eliminated" motif, distinct
// from the other three (dashed halve-line, closed-mark X, plain rings).
export const KILLER_ICON = `<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="2">
    <circle cx="16" cy="12" r="8"/>
    <circle cx="16" cy="12" r="3" fill="currentColor" stroke="none"/>
    <line x1="8" y1="23" x2="24" y2="28" stroke-linecap="round"/>
    <line x1="8" y1="28" x2="24" y2="23" stroke-linecap="round"/>
</svg>`;

// A triangle rack of balls - the pyramid the reds start in, immediately
// readable as "snooker/pool" and distinct from every dartboard-based icon
// above.
export const SNOOKER_ICON = `<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="2">
    <circle cx="16" cy="9" r="4" fill="currentColor" stroke="none"/>
    <circle cx="11" cy="17" r="4"/>
    <circle cx="21" cy="17" r="4"/>
    <circle cx="6" cy="25" r="4"/>
    <circle cx="16" cy="25" r="4"/>
    <circle cx="26" cy="25" r="4"/>
</svg>`;
